import { render } from "./AddTransfert.vue?vue&type=template&id=d768297c&ts=true"
import script from "./AddTransfert.vue?vue&type=script&lang=ts"
export * from "./AddTransfert.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__